import { render, staticRenderFns } from "./ShopOld.vue?vue&type=template&id=e860ff50&scoped=true"
import script from "./ShopOld.vue?vue&type=script&lang=js"
export * from "./ShopOld.vue?vue&type=script&lang=js"
import style0 from "./ShopOld.vue?vue&type=style&index=0&id=e860ff50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e860ff50",
  null
  
)

export default component.exports